// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"575b8a72","897":"5cdecb34"}[chunkId] + ".chunk.js";
};